import { combineReducers } from 'redux'
import userLogin from './LoginReduce'
import usersList from './UserMgmtReduce'
import usersTrafficLogList from './UserTrafficLogReduce'
import companiesList from './CompanyListReduce'
import deptsList from './DeptListReduce'
import contractorsList from './ContractorListReduce'
import conformityCategoriesList from './ConformityCategoryListReduce'
import locationsList from './LocationListReduce'
import workLocationsList from './WorkLocationListReduce'
import contractorCategoriesList from './ContractorCategoryListReduce'
import notifications from './NotifsReduce'
import contractorPitLookups from './ContractorPitLookupReduce'
import ccsList from './CCListReduce'
import tunnels from './TunnelsReduce'
import { groupList, permissionList } from './GroupMgmtReduce'
import {
  collabSupportRequest,
  collabConformityReport,
} from './CollaborationReduce'
import {
  effectivePitPlan,
  supportRequestLookup,
  conformityReportLookup,
  lookups,
  romLookups,
} from './LookupReduce'
import {
  supportRequests,
  conformityReports,
  currentSupportReq,
  currentConformityRep,
} from './TaskReduce'
import { viewState } from './ViewReduce'
import globals from './GlobalReduce'
import settingsTable from './SettingsTableReduce'
import dailyReportList from './DailyReportReduce'
import historyDataValidationList from './DataValidationReduce'
import DailyLoadingPointList from './DailyLoadingPointReduce'
import { blastingReportDetail, blastingReports } from './BlastingReportReduce'
import { romLocationsList, romLocationDetailId } from './RomLocationListReduce'
import { areaList, dirLocationList } from './AreaReduce'
import { productList } from './ProductReduce'

const rootReducer = combineReducers({
  userLogin,
  usersList,
  usersTrafficLogList,
  companiesList,
  deptsList,
  groupList,
  permissionList,
  contractorsList,
  locationsList,
  workLocationsList,
  contractorCategoriesList,
  contractorPitLookups,
  supportRequests,
  conformityReports,
  ccsList,
  currentSupportReq,
  currentConformityRep,
  collabSupportRequest,
  collabConformityReport,
  effectivePitPlan,
  supportRequestLookup,
  conformityReportLookup,
  conformityCategoriesList,
  lookups,
  romLookups,
  tunnels,
  notifications,
  viewState,
  globals,
  settingsTable,
  dailyReportList,
  historyDataValidationList,
  DailyLoadingPointList,
  blastingReportDetail,
  blastingReports,
  romLocationsList,
  romLocationDetailId,
  areaList,
  dirLocationList,
  productList,
})

export default rootReducer
